/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateAddressDto
 */
export interface CreateAddressDto {
    /**
     * Address name/label
     * @type {string}
     * @memberof CreateAddressDto
     */
    'name': string;
    /**
     * Contact number for this address
     * @type {string}
     * @memberof CreateAddressDto
     */
    'contactNumber': string;
    /**
     * Address type
     * @type {string}
     * @memberof CreateAddressDto
     */
    'type': CreateAddressDtoTypeEnum;
    /**
     * Country name
     * @type {string}
     * @memberof CreateAddressDto
     */
    'country': string;
    /**
     * Country code
     * @type {string}
     * @memberof CreateAddressDto
     */
    'countryCode': string;
    /**
     * Province name
     * @type {string}
     * @memberof CreateAddressDto
     */
    'province': string;
    /**
     * Province code
     * @type {string}
     * @memberof CreateAddressDto
     */
    'provinceCode': string;
    /**
     * City name
     * @type {string}
     * @memberof CreateAddressDto
     */
    'city'?: string;
    /**
     * City code
     * @type {string}
     * @memberof CreateAddressDto
     */
    'cityCode'?: string;
    /**
     * Barangay name
     * @type {string}
     * @memberof CreateAddressDto
     */
    'barangay'?: string;
    /**
     * Barangay code
     * @type {string}
     * @memberof CreateAddressDto
     */
    'barangayCode'?: string;
    /**
     * Street address
     * @type {string}
     * @memberof CreateAddressDto
     */
    'street'?: string;
    /**
     * Additional address line (apartment, unit, floor, building)
     * @type {string}
     * @memberof CreateAddressDto
     */
    'addressLine2'?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof CreateAddressDto
     */
    'postalCode'?: string;
    /**
     * Source API for address data
     * @type {string}
     * @memberof CreateAddressDto
     */
    'sourceApi'?: CreateAddressDtoSourceApiEnum;
}

export const CreateAddressDtoTypeEnum = {
    Home: 'home',
    Work: 'work',
    Shipping: 'shipping'
} as const;

export type CreateAddressDtoTypeEnum = typeof CreateAddressDtoTypeEnum[keyof typeof CreateAddressDtoTypeEnum];
export const CreateAddressDtoSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type CreateAddressDtoSourceApiEnum = typeof CreateAddressDtoSourceApiEnum[keyof typeof CreateAddressDtoSourceApiEnum];


